export default [
  // 添加学员试听备注
  {
    name: 'add-audition-remark',
    component: () => import(/* webpackChunkName: "addAuditionRemarkPopup" */ './add-audition-remark.vue'),
  },
  // 缺勤记录
  {
    name: 'course-absent-log',
    component: () => import(/* webpackChunkName: "courseAbsentLogPopup" */ './course-absent-log.vue'),
  },
  // 添加学员入班弹窗
  {
    name: 'course-arrange-add-student',
    component: () => import(/* webpackChunkName: "courseArrangeAddStudentPopup" */ './course-arrange-add-student.vue'),
  },
  // 添加学员入班选择日期
  {
    name: 'course-arrange-add-student-date',
    component: () => import(/* webpackChunkName: "courseArrangeAddStudentDatePopup" */ './course-arrange-add-student-date.vue'),
  },
  // 排课批量编辑弹窗
  {
    name: 'course-arrange-batch-edit-popup',
    component: () => import(/* webpackChunkName: "courseArrangeBatchEditPopup" */ './course-arrange-batch-edit-popup.vue'),
  },
  // 修改备注
  {
    name: 'md-remark',
    component: () => import(/* webpackChunkName: "md-remark" */ './md-remark.vue'),
  },
  // 排课冲突弹窗
  {
    name: 'multi-arrange-conflict-popup',
    component: () => import(/* webpackChunkName: "multiArrangeConflictPopup" */ './multi-arrange-conflict-popup.vue'),
  },
];
